export const CREATION_STAGE = 'CREATION_STAGE'

export const JOB_TYPE = 'jobType'
export const MAIL_TO = 'mailTo'
export const CRON_START = 'cronStart'
export const CRON_END = 'cronEnd'
export const MONTHDAYS = 'monthdays'
export const MINUTES = 'minutes'
export const HOURS = 'hours'
export const MONTHS = 'months'
export const WEEKDAYS = 'weekdays'
export const TIMEZONE = 'timezone'

export const DAILY = 'daily'

export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm'
export const DEFAULT_LOCALE = 'en-GB'

export const initialValues = {
  jobType: '',
  mailTo: [],
  cronStart: null,
  cronEnd: null,
  monthdays: [],
  minutes: '',
  hours: '',
  months: [],
  weekdays: [],
  timezone: '',
  cronExp: null
}

export const days = Array(31)
  .fill(0)
  .map((_, i) => ({ value: (i + 1).toString(), label: i + 1 }))
